// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

import keyMirror from 'utils/key_mirror';

export default keyMirror({
    GET_CUSTOM_EMOJI_REQUEST: null,
    GET_CUSTOM_EMOJI_SUCCESS: null,
    GET_CUSTOM_EMOJI_FAILURE: null,

    GET_CUSTOM_EMOJIS_REQUEST: null,
    GET_CUSTOM_EMOJIS_SUCCESS: null,
    GET_CUSTOM_EMOJIS_FAILURE: null,

    GET_ALL_CUSTOM_EMOJIS_REQUEST: null,
    GET_ALL_CUSTOM_EMOJIS_SUCCESS: null,
    GET_ALL_CUSTOM_EMOJIS_FAILURE: null,

    CREATE_CUSTOM_EMOJI_REQUEST: null,
    CREATE_CUSTOM_EMOJI_SUCCESS: null,
    CREATE_CUSTOM_EMOJI_FAILURE: null,

    DELETE_CUSTOM_EMOJI_REQUEST: null,
    DELETE_CUSTOM_EMOJI_SUCCESS: null,
    DELETE_CUSTOM_EMOJI_FAILURE: null,

    CLEAR_CUSTOM_EMOJIS: null,
    RECEIVED_CUSTOM_EMOJI: null,
    RECEIVED_CUSTOM_EMOJIS: null,
    DELETED_CUSTOM_EMOJI: null,
    CUSTOM_EMOJI_DOES_NOT_EXIST: null,
});
